import { createSlice } from '@reduxjs/toolkit';
import { noop } from 'lodash';

import { getUserUploads } from '~/redux/thunks/fileUpload';

export const initialState = {
  isUploadInfoPanelOpen: false,
  uploadLogs: [],
};

/*************
 * Reducers
 *************/
const openUploadInfoPanelReducer = (state: any) => {
  state.isUploadInfoPanelOpen = true;
};
const closeUploadInfoPanelReducer = (state: any) => {
  state.isUploadInfoPanelOpen = false;
};
const setUploadLogsReducer = (state: any, { payload }: { payload: any }) => {
  state.uploadLogs = payload.results;
};

/*************
 * Slice Definition
 *************/
export default createSlice({
  name: 'fileUpload',
  initialState,
  selectors: {
    selectIsUploadInfoPanelOpen: (state) => state.isUploadInfoPanelOpen,
    selectUploadLogs: (state) => state.uploadLogs,
  },
  reducers: {
    openUploadInfoPanel: openUploadInfoPanelReducer,
    closeUploadInfoPanel: closeUploadInfoPanelReducer,
    setUploadLogs: setUploadLogsReducer,
  },
  extraReducers: (builder) => {
    builder.addCase(getUserUploads.fulfilled, setUploadLogsReducer);
    builder.addCase(getUserUploads.rejected, noop);
  },
});
